export enum AuthErrorCodes {
    InvalidCredentials = 1,
    AccessDenied = 2,
    Unknown = 1000,
}

export class AuthError {
    private paddingLength = 4;

    constructor(private code: AuthErrorCodes, private message: string = '', private error: any = {}) {
    }

    get errorCodeFormatted(): string {
        return AuthError.padLeft0(this.errorCode, this.paddingLength);
    }

    get errorCode(): AuthErrorCodes {
        return this.code;
    }

    get errorMessage(): string {
        return this.message ? this.message : 'Unknown authentication error.';
    }

    get isGlobalMessage(): boolean {
        return this.errorCode >= 1000;
    }

    private static padLeft0(value: AuthErrorCodes, length: number): string {
        let result = value + '';
        while (result.length < length) {
            result = '0' + result;
        }
        return result;
    }
}
